<script>
	import { onMount } from "svelte";
	import { algorithmVersionAll as all } from "../../stores";
	import { postApi as post, putApi as put, delApi as del } from "../../service/api";
	import { Dates } from "../../utils/date";
	import TableToolbar from "../../components/TableToolbar.svelte";
	import Pagination from "../../components/Pagination.svelte";
	import { menu, menuSub, menuSubSub } from "../../stores";

	// 상수 정의
	const BASE_URL = "/version/algorithm";
	const PAGE_SIZES = [10, 15, 20, 25, 30, 50, 100];
	let pageSize = 10; // 페이지당 항목 수
	let totalItems = 0;

	const ACTIVE_OPTIONS = [
		{ value: true, text: "사용" },
		{ value: false, text: "미사용" },
	];

	// 상태 관리
	let isEditMode = false;
	let editingRowId = null;
	let focusField = "versionCode";
	let filteredData = [];

	// 페이징 상태
	let currentPage = 1;
	let totalPages = 1;

	// 편집 아이템 초기값
	const defaultEditItem = {
		id: 0,
		versionName: "",
		description: "",
		isActive: false,
	};

	let editItem = { ...defaultEditItem };

	// 메서드
	const setFocus = (field = "versionName") => {
		focusField = field;
	};

	const validateItem = () => {
		if (!editItem.versionName) {
			alert("버전명을 입력하세요.");
			setFocus("versionName");
			return false;
		}
		return true;
	};

	const handleSave = async () => {
		if (!validateItem()) return;

		const payload = {
			...editItem,
			isActive: Boolean(editItem.isActive),
		};

		(await editItem.id) ? put(BASE_URL, payload) : post(BASE_URL, payload);

		await fnSearch();
	};

	const fnSearch = async () => {
		await all.fetch(`${BASE_URL}/${pageSize}/${currentPage}`);
		resetEdit();
	};

	const resetEdit = () => {
		isEditMode = false;
		editingRowId = null;
		editItem = { ...defaultEditItem };
	};

	const fnProcessRegist = () => {
		if (!isEditMode) {
			isEditMode = true;
			editingRowId = null;
			editItem = { ...defaultEditItem };
			focusFirstInput();
		}
	};

	const focusFirstInput = () => {
		setTimeout(() => {
			const versionNameInput = document.querySelector('input[type="text"]');
			if (versionNameInput) {
				versionNameInput.focus();
				versionNameInput.select();
			}
		});
	};

	const fnProcessEdit = (item) => {
		if (!isEditMode) {
			isEditMode = true;
			editingRowId = item.id;
			editItem = { ...item };
			focusFirstInput();
		}
	};

	const fnDelete = async (id) => {
		const item = $all.data.list.find((item) => item.id === id);
		if (item.isActive) {
			alert("사용 중인 알고리즘 버전은 삭제할 수 없습니다.");
			return;
		}

		if (confirm("정말 삭제하시겠습니까?")) {
			await del(BASE_URL, { id });
			await fnSearch();
		}
	};

	const fnRegistServer = () => {
		if (confirm("서버에 적용하시겠습니까?")) {
			put(`${BASE_URL}/cache`, {}).then((success) => {
				if (success) {
					alert("서버 적용이 완료되었습니다.");
				}
			});
		}
	};

	// 페이지 변경 핸들러
	const handlePageChange = (page) => {
		if (page < 1 || page > totalPages) return;
		currentPage = page;
		fnSearch();
	};

	const handlePageSizeChange = (event) => {
		pageSize = parseInt(event.target.value); // pageSize 값 업데이트
		currentPage = 1; // 페이지를 1로 리셋
		fnSearch(); // 목록 새로고침
	};

	$: {
		const data = $all?.data || {};
		filteredData = data.list || [];
		totalPages = Math.ceil((data.total || 0) / pageSize);
		totalItems = data.total || 0;
	}

	onMount(() => {
		menu.set("버전 관리");
		menuSub.set("알고리즘 버전");
		menuSubSub.set("");
		fnSearch();
	});
</script>

<div class="card mb-4">
	<div class="table-responsive text-nowrap">
		<TableToolbar
			{totalItems}
			{currentPage}
			{totalPages}
			{pageSize}
			pageSizes={PAGE_SIZES}
			onPageSizeChange={handlePageSizeChange}
			onReload={fnSearch}
			onRegist={fnProcessRegist}
			onRegistServer={fnRegistServer}
		/>
		<div class="fade-container">
			<!-- 메인 테이블 -->
			<table class="table small">
				<thead>
					<tr style="text-align:center">
						<th width="80">No</th>
						<th width="120">버전명</th>
						<th width="*">설명</th>
						<th width="120">사용여부</th>
						<th width="150">등록일시</th>
						<th width="150">수정일시</th>
						<th width="150">관리</th>
					</tr>
				</thead>
				<tbody>
					{#if isEditMode && !editingRowId}
						<tr style="text-align:center">
							<td />
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.versionName}
									on:focus={() => setFocus("versionName")}
								/>
							</td>
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.description}
									on:focus={() => setFocus("description")}
								/>
							</td>
							<td>
								<div class="form-check form-switch d-flex justify-content-center">
									<input class="form-check-input" type="checkbox" id="isActive-new" bind:checked={editItem.isActive} />
								</div>
							</td>
							<td />
							<td />
							<td>
								<button class="btn btn-sm btn-primary me-1" on:click={handleSave}>Save</button>
								<button class="btn btn-sm btn-outline-secondary" on:click={resetEdit}>Cancel</button>
							</td>
						</tr>
					{/if}

					{#each filteredData as item, index}
						{#if editingRowId === item.id}
							<tr style="text-align:center; font-size: 12px;">
								<td>{totalItems - ((currentPage - 1) * pageSize + index)}</td>
								<td>
									<input
										type="text"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.versionName}
										on:focus={() => setFocus("versionName")}
									/>
								</td>
								<td>
									<input
										type="text"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.description}
										on:focus={() => setFocus("description")}
									/>
								</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" id="isActive-edit" bind:checked={editItem.isActive} />
									</div>
								</td>
								<td>{Dates.defaultConvertFull(item.createdAt)}</td>
								<td>{Dates.defaultConvertFull(item.updatedAt)}</td>
								<td>
									<button class="btn btn-sm btn-primary me-1" on:click={handleSave}>Save</button>
									<button class="btn btn-sm btn-outline-secondary" on:click={resetEdit}>Cancel</button>
								</td>
							</tr>
						{:else}
							<tr style="text-align:center; font-size: 12px;">
								<td>{totalItems - ((currentPage - 1) * pageSize + index)}</td>
								<td>{item.versionName}</td>
								<td>{item.description}</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" checked={item.isActive} disabled readonly />
									</div>
								</td>
								<td>{Dates.defaultConvertFull(item.createdAt)}</td>
								<td>{Dates.defaultConvertFull(item.updatedAt)}</td>
								<td>
									<button class="btn btn-sm btn-outline-primary me-1" on:click={() => fnProcessEdit(item)}>Edit</button>
									<button class="btn btn-sm btn-outline-primary" on:click={() => fnDelete(item.id)}>Delete</button>
								</td>
							</tr>
						{/if}
					{/each}
				</tbody>
			</table>
		</div>
		<Pagination {currentPage} {totalPages} onPageChange={handlePageChange} />
	</div>
</div>
